import { MockExamEditPage } from "@/features/learning-content/pages/MockExamEdit";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const MockExamEdit: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <MockExamEditPage />
      </Box>
    </Stack>
  );
};

export default MockExamEdit;
